module.exports = __webpack_public_path__ + "static/media/WorkSans-SemiBold.7b97e2b9.ttf";